import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StatusUpdateService {

  private statusUpdateUrl = `${environment.common}/updatestatus`;
  private quoteapiUrl = `${environment.travel}/quotes`;

  constructor(
    private _http: HttpClient
  ) { }

  updateStatusOfRecord(entity:any, id:any, value:any){
    return this._http.put(`${this.statusUpdateUrl}?entitytype=${entity}&id=${id}&value=${value}`, {});
  }

  finalizeQuote(leadId:any, quoteId:any){
    return this._http.put(`${this.quoteapiUrl}/${leadId}/${quoteId}`, {});
  }

  finalizeDmcQuote(leadId:any, quoteId:any){
    return this._http.put(`${environment.dmc}/quotes/${leadId}/${quoteId}`, {});
  }
}
